import React from 'react'
import {BrowserRouter as Router} from 'react-router-dom'
import 'materialize-css'
import { useRoutes } from './routes'
import { useAuth } from './hooks/auth.hook'
import { AuthContext } from './context/AuthContext'
import { useBase } from './hooks/base.hook'
import { BaseContext } from './context/BaseContext'
import { Navbar } from './components/Navbar'
import { Loader } from './components/Loader'
import { useCard } from './hooks/card.hook'
import { CardContext } from './context/CardContext'

function App() {
  const {token, login, logout, userId, ready, username} = useAuth()
  const {base, selectBase, clearBase} = useBase()
  const {createForm, cardForm, homeConfirm, setHomeConfirm, pendingTarget, setPendingTarget} = useCard()
  const isAuthenticated = !!token
  const routes = useRoutes(isAuthenticated, base)
  if (!ready){
    return <Loader/>
  }
  return (
    <AuthContext.Provider value={{token, login, logout, userId, isAuthenticated, username}}>
      <BaseContext.Provider value={{base, selectBase, clearBase}}>
        <CardContext.Provider value={{createForm, cardForm, homeConfirm, setHomeConfirm, pendingTarget, setPendingTarget}}>
          <Router>
            {isAuthenticated && <Navbar/>}
            <div className="container">
              {routes}
            </div>
          </Router>
        </CardContext.Provider>
      </BaseContext.Provider>
    </AuthContext.Provider>
  )
}

export default App